module.exports = __webpack_public_path__ + "static/media/tradesDark.47c5629f.svg";